import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { CollectionFormFields, RawCollection, ResourceType } from '../types';
import { isCollectionKimeraError } from '../utils/isCollectionKimeraError';

const URL = pathfinder('create_collection');

interface Resource {
    resourceId: string;
    resourceType: ResourceType;
}

interface ApiResource {
    resource_id: string;
    resource_type: ResourceType;
}

interface CreateCollectionPayload extends CollectionFormFields {
    items: ApiResource[];
}

interface CreateCollectionResponse {
    collection: RawCollection;
}

export const createCollection = async (
    collection: CollectionFormFields,
    initialResource?: Resource
): Promise<CreateCollectionResponse['collection']> => {
    try {
        const payload = {
            ...collection,
            items: initialResource
                ? [
                      {
                          resource_id: initialResource.resourceId,
                          resource_type: initialResource.resourceType,
                      },
                  ]
                : [],
        } satisfies CreateCollectionPayload;
        const response = await axios.post<CreateCollectionResponse>(URL, payload);

        return response.data.collection;
    } catch (error) {
        if (!isCollectionKimeraError(error)) {
            logger.error(error as Error, { description: 'Failed to create collection' });
        }
        throw error;
    }
};
